import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ページ遷移時にスクロール位置をページ上部へ戻す。
 * 遷移カーテン（Layout.tsx / 退場は0.6sで覆いきる）が画面を覆ってから
 * スクロールさせることで、旧ページが飛び上がる瞬間を見せない。
 * html に scroll-behavior: smooth が効いているため、一時的に無効化して即座に移動する。
 */
export default function ScrollToTop() {
  // 同じページへの遷移でもスクロールを戻すため pathname ではなく key を見る
  const { key } = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      const html = document.documentElement;
      const prev = html.style.scrollBehavior;
      html.style.scrollBehavior = "auto";
      window.scrollTo(0, 0);
      html.style.scrollBehavior = prev;
    }, 620);
    return () => clearTimeout(timer);
  }, [key]);

  return null;
}
